export const POPPER_PORTAL_ID = 'floating-ui-root'
